<template>
  <div class="fs-background fs-background--fullscreen">
    <div class="form-container form-container--floating">
      <div class="logo logo--wcz"/>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-text-field
          autocomplete="email"
          autofocus
          solo
          v-model="email"
          validate-on-blur
          :rules="emailRules"
          prepend-icon="fa-envelope"
          v-bind:disabled="isFetching || !!gracePeriodRemaining"
          :label="$t('forms.email')"
          required
        ></v-text-field>
        <div class="actions">
          <v-btn
            class="lowercase mr-0"
            @click="resetPassword"
            v-bind:loading="isFetching"
            color="primary"
            v-bind:disabled="isFetching || !!gracePeriodRemaining"
            v-t="'buttons.resetPassword'"
          >
          </v-btn>
          <v-btn
            class="hyperlink lowercase mx-0 mb-0"
            flat
            text
            color="primary"
            to="/inloggen"
            v-t="'buttons.back'"
          >
          </v-btn>
        </div>
      </v-form>
      <v-alert
        :value="hasResetRecently"
        type="success"
        outline
      >
        <i18n
          path="messages.resetEmailSent.text"
          tag="div"
        >
          <strong>{{ gracePeriodRemaining }}</strong>
        </i18n>
      </v-alert>
      <v-alert
        :value="error"
        type="error"
        outline
      >
        <msp-api-error
          v-if="error"
          :response="error"
        />
      </v-alert>
    </div>
  </div>
</template>

<script>

const RESET_GRACE_PERIOD = 60 * 1000; // 5 minutes

export default {

  data() {
    return {
      error: null,
      valid: false,
      email: '',
      gracePeriodRemaining: 0,
      emailRules: [
        v => !!v || 'E-mail is vereist',
        v => /.+@.+/.test(v) || 'Voer een geldig e-mailadres in',
      ],
    };
  },

  mounted() {
    const {
      email,
      token,
    } = this.$router.currentRoute.query;

    if (email && token) {
      this.$router.replace({
        name: 'setPassword',
        params: {
          email: unescape(email),
          token: unescape(token),
        },
      });
    }

    if (this.hasResetRecently) {
      this.countdown();
    }

    this.$nextTick(() => {
      this.$refs.form.reset();
      this.error = null;
    });
  },

  computed: {
    isFetching() {
      return this.$store.state.account.isFetching;
    },

    hasResetRecently() {
      const { lastReset } = this.$store.state.account;

      return lastReset && (Date.now() - lastReset < RESET_GRACE_PERIOD);
    },
  },
  watch: {},
  methods: {
    async resetPassword() {
      if (this.$refs.form.validate()) {
        this.error = null;

        try {
          await this.$store.dispatch('account/resetPassword', { email: this.email });
          this.countdown();
        } catch (error) {
          this.error = error;
        }
      }
    },

    countdown() {
      this.$nextTick(() => {
        const { lastReset } = this.$store.state.account;

        const timePassed = Date.now() - lastReset;

        if (timePassed < RESET_GRACE_PERIOD) {
          this.gracePeriodRemaining = parseInt((RESET_GRACE_PERIOD - timePassed) / 1000, 0);
          setTimeout(() => this.countdown(), 250);
          return;
        }

        this.gracePeriodRemaining = 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.logo--wcz {
  position: absolute;
  top: -64px;
  height: 100px;
  width: 300px;
}

.v-alert {
  max-width: 400px;
}

.actions {
  display: flex;
  flex-direction: column;
  text-transform: none;
}

.hyperlink {
  text-decoration: underline;
}

.lowercase {
  text-transform: none;
}
</style>
